import * as React from 'react';

import { cl } from 'lincd/utils/ClassNames';
import { asset } from 'lincd/utils/LinkedFileStorage';
import style from './LogoSpinning.module.css';

export function LogoSpinning({ centered }: { centered?: boolean }) {
  return (
    <img
      className={cl(style.globe, centered && style.centered)}
      src={asset('/images/peace-game-logo-spinning-2.gif')}
      alt="Peace Game logo"
      aria-label="Peace Game logo"
    />
  );
}
